export const changePassRoutes = {
  FORGOT_PASS: "/auth/restore",
  CONFIRM_FORGOT_PASS: "/auth/confirm/restore",
  SET_NEW_PASS: "/auth/password/new",
  GET_TOKEN_HASH: "/token/check",
}